export default __webpack_public_path__ + "static/compareItemImg5-4443f04fd0352ca023834ec041849424.png";